import { Component, Inject, inject, signal } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-password-reset-dialog',
  templateUrl: 'password-reset-dialog.component.html',
  styleUrls: ['password-reset-dialog.component.css'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ]
})
export class PasswordResetDialogComponent {
  private authService = inject(AuthService);
  
  public showCodeForm = signal(false);
  public errorMessage = signal<string | null>(null);

  // Declare controls but don't initialize here
  public usernameControl: FormControl;
  public codeControl: FormControl;
  public newPasswordControl: FormControl;

  constructor(
    public dialogRef: MatDialogRef<PasswordResetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { username: string }
  ) {
    // Initialize controls inside the constructor
    this.usernameControl = new FormControl(this.data.username || '', { nonNullable: true });
    this.codeControl = new FormControl('', { nonNullable: true });
    this.newPasswordControl = new FormControl('', { nonNullable: true });
  }

  async requestPasswordReset() {
    this.errorMessage.set(null);
    try {
      await this.authService.forgotPassword(this.usernameControl.value);
      this.showCodeForm.set(true);
    } catch (error: any) {
      this.handleError(error);
    }
  }

  async confirmPasswordReset() {
    this.errorMessage.set(null);
    try {
      await this.authService.confirmNewPassword(
        this.usernameControl.value,
        this.codeControl.value,
        this.newPasswordControl.value
      );
      this.dialogRef.close(true);
      alert('Your password has been reset successfully!');
    } catch (error: any) {
      this.handleError(error);
    }
  }

  private handleError(error: any) {
    console.error(error);
    if (error.code === 'UserNotFoundException') {
      this.errorMessage.set('The user was not found.');
    } else if (error.code === 'InvalidPasswordException') {
      this.errorMessage.set('Password does not meet requirements.');
    } else {
      this.errorMessage.set(error.message || 'An unknown error occurred.');
    }
  }
}